import { GraphQLClient } from 'graphql-request';

const graphqlRequestClient = new GraphQLClient('/api/content');

export default graphqlRequestClient;
